// src/app/core/api/index.ts
// Portal Dewelopera - API Layer Index
// Central export point for the entire API layer
// Last updated: 2025-11-26

// ============================================
// MAIN API SERVICE (Single Unified Service)
// ============================================
export { ApiService } from './api.service';

// ============================================
// ALL MODELS (Single File Export)
// ============================================
export * from './models';

// ============================================
// HTTP INTERCEPTORS (if they exist)
// ============================================
// Uncomment these when interceptors are created:
// export { ErrorHandlingInterceptor } from './interceptors/error-handling.interceptor';
// export { LoadingInterceptor, LoadingService } from './interceptors/loading.interceptor';
// export { ApiBaseUrlInterceptor } from './interceptors/api-base-url.interceptor';

// ============================================
// CONVENIENCE RE-EXPORTS
// ============================================

// Developer types
export type {
  DeveloperDto,
  DeveloperCommand,
  CreateDeveloperCommand
} from './models';

// Place types (Selling Points)
export type {
  PlaceDto,
  SellingPointDto,
  SellingPointRequest,
  LocationRequest,
  OpeningHours
} from './models';

// Investment types
export type {
  InvestmentDto,
  InvestmentWithCountsDto,
  InvestmentDetailsWithCountsDto,
  InvestmentCountsDto,
  InvestmentSelectOptionDto,
  // OPENAPI-GEN:BEGIN index-investment-building-types
  BuildingDto,
  BuildingRequest,
  CreateBuildingRequest,
  BuildingAddressDto,
  BuildingAddressRequest,
  ApartmentBuildingCreateRequest,
  BuildingToCreateRequest,
  // OPENAPI-GEN:END index-investment-building-types
  InvestmentRequest,
  CreateInvestmentRequest
} from './models';

// Apartment types
export type {
  ApartmentDto,
  ApartmentDetailsDto,
  ApartmentListItemView,
  ApartmentListBuildingView,
  ApartmentListBuildingAddressView,
  ApartmentVersionDto,
  // OPENAPI-GEN:BEGIN index-apartment-patch-type
  PatchApartmentRequest,
  // OPENAPI-GEN:END index-apartment-patch-type
  ApartmentVersionRequest,
  UpdateApartmentVersionRequest,
  PageApartmentListItemDto
} from './models';

// Parking types
export type {
  ParkingDto,
  ParkingDetailsDto,
  ParkingListItemView,
  ParkingTypeView,
  ParkingVersionDto,
  ParkingRequest,
  CreateParkingRequest,
  ParkingVersionRequest,
  ParkingTypeDto,
  ParkingTypeRequest
} from './models';

// Ancillary Space types
export type {
  AncillaryDetailsDto,
  AncillaryListItemView,
  AncillaryVersionDto,
  AncillaryRequest,
  CreateAncillaryRequest,
  AncillaryVersionRequest,
  AncillaryTypeDto,
  AncillaryType,
  AncillaryTypeRequest
} from './models';

// Addon Rules types
export type {
  ApartmentAddonRuleDto,
  ApartmentAddonRuleRequest,
  AddonRule,
  AddonRuleRequest,
  Variant,
  VariantRequest,
  Condition,
  ConditionRequest,
  ItemRef,
  ItemRefRequest,
  TypeRef,
  TypeRefRequest
} from './models';

// User types
export type {
  UserEntity,
  UserDto,
  CreateUserCommand,
  PageResponseUserDto
} from './models';

// Auth types
export type {
  LoginRequest,
  AuthResponseDto,
  TokenResponse
} from './models';

// Shared types
export type {
  PictureMediaItem,
  EntityStatus,
  DayOfWeek,
  PlaceType,
  GlobalRole,
  AddonDomain,
  PaginationParams,
  ApiError,
  PageableObject,
  SortObject
} from './models';
